<template>
<div>
  <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t('playerSetup.DisplaysArrangement') }}</h2>
  <span class="hidden grid-cols-2 grid-cols-3 grid-cols-4 bg-blue-200 border-black border-[#23569F]"></span>
  <el-form
    @submit.prevent="triggerFormSubmit"
      ref="refFormArrangement"
      :model="model"
      class="common-form">
    <el-row>
      <el-col class="player-setup-arrangement">
        <div v-if="orientation == 'horizontal'">
          <div :class="'pt-20 ' + (outputs === 4 ? 'pl-[2.6rem]' : '')">
            <el-form-item prop="arrangement" class="flex justify-center">
              <!-- vertial -->
              <el-radio
                  tabindex="1"
                  v-model="model.arrangement"
                  ref="horizontalVerticalArrangement"
                  class="h-auto! w-auto!"
                  :label="getArrangement('horizontal', outputs, arrangements.vertical)">
                <div class="grid grid-cols-1 gap-0">
                  <div
                    v-for="i in outputsRange"
                    :key="'hv' + i"
                    :class="[{ 'border-t-black': i > 0 }, 'border-[#909090] border border-b-0 w-[46px] h-[31px]']"></div>
                  <div class="border-[#909090] border border-t-black w-[46px] h-[31px]"></div>
                </div>
              </el-radio>

              <!-- horizontal -->
              <el-radio
                  tabindex="2"
                  v-model="model.arrangement"
                  ref="horizontalHorizontalArrangement"
                  class="h-auto! w-auto!"
                  :label="getArrangement('horizontal', outputs, arrangements.horizontal)">
                <div :class="'grid gap-0 ml-12 grid-cols-' + outputs">
                  <div v-for="i in outputsRange" :key="'hh' + i" :class="[{ 'border-l-black': i > 0 }, 'border-[#909090] border border-r-0 w-[46px] h-[31px]']"></div>
                  <div class="border-[#909090] border border-l-black w-[46px] h-[31px]"></div>
                </div>
              </el-radio>
              <!-- 2x2 -->
              <el-radio
                  v-if="outputs == 4"
                  tabindex="3"
                  v-model="model.arrangement"
                  class="h-auto! w-auto!"
                  ref="horizontal2x2Arrangement"
                  :label="getArrangement('horizontal', outputs, arrangements.horizontal_x2x2)">
                <div class="grid grid-cols-2 gap-0 ml-12">
                  <div class="border-[#909090] border border-b-0 border-r-0 w-[46px] h-[31px]"></div>
                  <div class="border-[#909090] border border-b-0 border-l-black w-[46px] h-[31px]"></div>
                  <div class="border-[#909090] border border-r-0 border-t-black w-[46px] h-[31px]"></div>
                  <div class="border-[#909090] border border-t-black border-l-black w-[46px] h-[31px]"></div>
                </div>
            </el-radio>
            </el-form-item>
          </div>
        </div>
        <div v-else>
          <div :class="'pt-12 ' + (outputs === 4 ? 'pl-8' : '')">
            <el-form-item prop="arrangement" class="flex justify-center">
              <!-- vertial -->
              <el-radio
                  tabindex="1"
                  v-model="model.arrangement"
                  ref="verticalVerticalArrangement"
                  class="h-auto! w-auto!"
                  :label="getArrangement('vertical', outputs, arrangements.vertical)">
                <div class="grid grid-cols-1 gap-0">
                  <div
                    v-for="i in outputsRange"
                    :key="'vv' + i"
                    :class="[{ 'border-t-black': i > 0 }, 'border-[#909090] border border-b-0 h-[46px] w-[31px]']"></div>
                  <div class="border-[#909090] border border-t-black h-[46px] w-[31px]"></div>
                </div>
              </el-radio>

              <!-- horizontal -->
              <el-radio
                  tabindex="2"
                  v-model="model.arrangement"
                  ref="verticalHorizontalArrangement"
                  class="h-auto! w-auto!"
                  :label="getArrangement('vertical', outputs, arrangements.horizontal)">
                <div :class="'grid gap-0 ml-12 grid-cols-' + outputs">
                  <div v-for="i in outputsRange" :key="'vh' + i" :class="[{ 'border-l-black': i > 0 }, 'border-[#909090] border border-r-0 h-[46px] w-[31px]']"></div>
                  <div class="border-[#909090] border border-l-black h-[46px] w-[31px]"></div>
                </div>
              </el-radio>
              <!-- 2x2 -->
              <el-radio
                  v-if="outputs == 4"
                  tabindex="3"
                  v-model="model.arrangement"
                  ref="vertical2x2Arrangement"
                  class="h-auto! w-auto!"
                  :label="getArrangement('vertical', outputs, arrangements.vertical_x2x2)">
                <div class="grid grid-cols-2 gap-0 ml-12">
                  <div class="border-[#909090] border border-b-0 border-r-0 h-[46px] w-[31px]"></div>
                  <div class="border-[#909090] border border-b-0 border-l-black h-[46px] w-[31px]"></div>
                  <div class="border-[#909090] border border-r-0 border-t-black h-[46px] w-[31px]"></div>
                  <div class="border-[#909090] border border-t-black border-l-black h-[46px] w-[31px]"></div>
                </div>
              </el-radio>
            </el-form-item>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="text-center">
        <p class="input-hint mt-4 text-xs text-gray-500">{{ $t('playerSetup.SelectDisplayArrangement') }}</p>
      </el-col>
    </el-row>
    </el-form>
</div>
</template>

<script src="./player-setup-arrangement.js"></script>
<style lang="scss" src="./player-setup-arrangement.scss"></style>
